<template>
  <span style="color:red; font-size: 1.5rem;">{{ message }}</span>
</template>

<script>
import constant from '@/const';

export default {
  props: {
    validation: {
      type: String
    },
    valueLength: {
    },
    valueMin: {
    },
    valueMax: {
    },
    valueInt: {
    },
    valueDouble: {
    }
  },
  computed: {
    message() {
      let message = constant.VALIDATION_MESSAGE[this.validation];
      if (this.validation === 'maxLength') {
        message = this.valueLength + constant.VALIDATION_MESSAGE[this.validation]
      }else if (this.validation === 'between') {
        message = constant.VALIDATION_MESSAGE[this.validation] + '（' + this.valueMin + '〜' + this.valueMax + '）'
      }else if (this.validation === 'customDoubleNum') {
        message = constant.VALIDATION_MESSAGE[this.validation] + '（整数' + this.valueInt + '桁まで　小数点以下' + this.valueDouble + '桁まで）'
      }
      return message;
    }
  },
}

</script>